import React, { useState } from "react";
import { Row, Col } from "antd";
import { useInView } from "react-intersection-observer";
import { gsap } from "gsap";

const StatsSection = () => {
  const stats = [
    {
      number: 3,
      description:
        "Pierce ears in three simple steps with Inverness: cleanse, mark, and pierce.",
      prefix: "1-2-",
    },
    {
      number: 70,
      description:
        "Inverness is available in over 50 countries, sold directly to retailers or through our authorized distribution partners.",
      suffix: "+",
    },
    {
      number: 200,
      description:
        "To date, we have successfully pierced over 200 million ears worldwide.",
      suffix: " Million+",
    },
  ];

  const { ref, inView } = useInView({ triggerOnce: true });
  const [counts, setCounts] = useState([0, 0, 0]);

  React.useEffect(() => {
    if (inView) {
      stats.forEach((stat, index) => {
        gsap.to(counts, {
          [index]: stat.number,
          duration: 2,
          ease: "power2.out",
          onUpdate: () => {
            setCounts([...counts]);
          },
        });
      });
    }
  }, [inView]);

  return (
    <div
      ref={ref}
      style={{
        backgroundColor: "#ffffff", // Change to a light color
        padding: "50px 0",
        borderRadius: "10px", // Add some border radius for rounded corners
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Add a subtle shadow for depth
        background: "linear-gradient(180deg, #ffffff 0%, #f0f8ff 100%)",
      }}
    >
      <Row gutter={16} justify="center">
        {stats.map((stat, index) => (
          <Col
            key={index}
            xs={24}
            sm={12}
            md={8}
            style={{
              textAlign: "center",
              padding: "20px",
              borderRight:
                index !== stats.length - 1 ? "1px solid #ddd" : "none", // Add a separator between columns
              backgroundColor: "#ffffff",
              padding: "20px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: "8px",
              margin: "20px",
            }}
          >
            <div
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                color: "#333333", // Darker font color for better contrast
              }}
            >
              {stat.prefix || ""}
              {Math.ceil(counts[index])}
              {stat.suffix || ""}
            </div>
            <div
              style={{
                marginTop: "10px",
                fontSize: "16px",
                lineHeight: "1.5",
                color: "#666666", // A slightly lighter color for the description text
              }}
            >
              {stat.description}
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default StatsSection;
